/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocCertIcon16Solid = forwardRef('DocCertIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1H4.5A2.5 2.5 0 0 0 2 3.5v8A2.5 2.5 0 0 0 4.5 14H7v1.5a.5.5 0 0 0 .8.4l1.05-.787a.25.25 0 0 1 .3 0l1.05.787a.5.5 0 0 0 .8-.4v-1.55a2.5 2.5 0 0 0 2-2.45V6H9.5A1.5 1.5 0 0 1 8 4.5V1Zm2.875 9a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z" }),
        React.createElement("path", { d: "M13 5 9 1v3.5a.5.5 0 0 0 .5.5H13Z" })));
});
